import Highcharts from 'highcharts';
import { getSMSizes } from '../ranking-sm/data.js';
import { loadPolandMapData } from '../ranking-sm/maps.js';

/**
 * @param {string} id
 */
export default async function mapBudget(id) {
    if (!document.getElementById(id)) return;

    const mapData = await loadPolandMapData();
    const smData = getSMSizes()
    smData.forEach(city => {
        city.b = city['Budżet'];
        city.l = city['Liczba mieszkańców'];
        city.e = city['Etaty: liczba strażników'];
    })

    const avgBudgetPerCitizen = smData.reduce((sum, city) => sum + city.b / city.l, 0) / smData.length;

    const budget = [...smData]
    budget.forEach(city => {
        city.z = city.b / city.l;
        city.value = city.z;
        city.x = city.lon;
        city.y = city.lat;
    })

    const series = [];

    if (mapData) {
        series.push({
            type: 'map',
            name: 'Poland',
            mapData,
            color: '#f0f0f0',
            borderColor: '#606060',
            borderWidth: 0.5,
            nullColor: '#f0f0f0',
            showInLegend: false,
            enableMouseTracking: false
        });
    }

    series.push({
        type: 'mapbubble',
        name: 'Budget per resident',
        data: budget,
        maxSize: '25%',
        minSize: '5%',
        colorAxis: 'budget-axis',
        colorKey: 'value',
        dataLabels: {
            enabled: true,
            format: '{point.city}<br>{point.z:,.0f} PLN',
            style: { fontSize: '11px', color: '#2c3e50', textOutline: '2px white' }
        }
    });

    // @ts-ignore
    Highcharts.mapChart(id, {
        chart: { backgroundColor: 'transparent' },
        title: { text: 'Annual city guard budget per resident' },
        subtitle: { text: `Average: ${avgBudgetPerCitizen.toFixed(0)} PLN` },
        mapNavigation: { enabled: false },
        colorAxis: {
            id: 'budget-axis',
            min: 20,
            max: 140,
            stops: [
                [0, '#e74c3c'],
                [0.5, '#f1c40f'],
                [1, '#2ecc71']
            ],
            labels: { format: '{value} PLN' }
        },
        tooltip: {
            pointFormat: '<b>{point.z:,.0f} PLN</b> per resident<br>Total budget: <b>{point.b:,.0f} PLN</b>'
        },
        credits: { enabled: false },
        series: series
    });
}
